import { connect } from 'react-redux';
import actions from '../redux/actions/order_history';
import OrderHistory from '../component/order_history/OrderHistory';

const mapStateToProps = (state) => ({
  order: state.order,
  coinSettings: state.setting.coinSettings,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchFilterOrderHistoryAction: (params, callback) => {
    dispatch(actions.fetchFilterOrderHistoryAction(params, callback));
  },
  searchOrderByID: (params, callback) => {
    dispatch(actions.searchOrderByIDAction(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);
